import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loadable from "./../Loadable";
import lazyWithRetry from "./../lazyWithRetry";
import Dashboard from "./../../Screens/AdminLayouts/Dashboard";
import AdminLayouts from "./../../Screens/AdminLayouts";
import PermissionGuard, {
  getFirstPermittedRoute,
} from "../../Components/PermissionGuard";
import Customers from "../../Screens/AdminLayouts/Customers";
import Categories from "../../Screens/AdminLayouts/Categories";
import AddRoles from "../../Screens/AdminLayouts/Roles&Permissions/AddRoles";
import AddEmployee from "../../Screens/AdminLayouts/EmployeeManagement/AddEmployee";
// import AddSupplier from '../../Screens/AdminLayouts/Supplier/AddSupplier';
import SupplierDetails from "../../Screens/AdminLayouts/Supplier/SupplierDetails";
import SupplierValidationLogs from "../../Screens/AdminLayouts/Supplier/ValidationLogs";
import SupplierLavel from "../../Screens/AdminLayouts/Supplier/SupplierLavel";
import PaymentReports from "../../Screens/AdminLayouts/Reports/PaymentReports";
import AddProduct from "./../../Screens/AdminLayouts/Products/AddProduct";
import ReportLogs from "../../Screens/AdminLayouts/Reports/ReportLogs";
import AddTaxation from "../../Screens/AdminLayouts/Taxation/AddTaxation";
import AddServiceFee from "../../Screens/AdminLayouts/Taxation/AddServiceFee";
import AddDeliveryFee from "../../Screens/AdminLayouts/Taxation/AddDeliveryFee";

// Redirects authenticated users from login/auth pages to their first permitted route
const AuthRedirect = () => {
  const permissions = useSelector(
    (state: any) => state.AuthSlice.adminAuthUser?.permissions,
  );
  return <Navigate to={getFirstPermittedRoute(permissions)} replace />;
};

const ProductList = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/Products/ProductList"),
  ),
);

// const AddProduct = Loadable(lazyWithRetry(() => import('./../../Screens/AdminLayouts/Products/AddProduct')));
const ProductDetail = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/Products/ProductDetail"),
  ),
);
const EmployeeManagement = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/EmployeeManagement"),
  ),
);
const Roles = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/Roles&Permissions/Roles"),
  ),
);
const EmployeeProfile = Loadable(
  lazyWithRetry(
    () =>
      import("./../../Screens/AdminLayouts/EmployeeManagement/EmployeeProfile"),
  ),
);
const CouponCode = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/CouponCode")),
);
const Orders = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/Orders")),
);
const Refunds = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/Refunds")),
);
const RefundDetails = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/Refunds/RefundDetails"),
  ),
);
const OrderDetails = Loadable(
  lazyWithRetry(
    () => import("./../../Screens/AdminLayouts/Orders/OrderDetails"),
  ),
);
const Settings = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/Settings")),
);
const AdminSettings = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/AdminSettings")),
);
const NotFound = Loadable(
  lazyWithRetry(() => import("./../../Screens/AdminLayouts/NotFound404")),
);
const CustomersDetail = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Customers/CustomersDetail"),
  ),
);
const SupplierList = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/Supplier")),
);
const MappingProductsAndSupplierCategory = Loadable(
  lazyWithRetry(
    () =>
      import("../../Screens/AdminLayouts/Supplier/MappingProductsAndSupplierCategory"),
  ),
);
const SalesReports = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Reports/SalesReports"),
  ),
);
const BankTransfers = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/BankTransfers/BankTransfersList"),
  ),
);
const PaymentFailures = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/PaymentFailures"),
  ),
);
const ProductReports = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Reports/ProductReports"),
  ),
);
const AuthProfile = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/AuthProfile")),
);
const ChangePassword = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/AuthProfile/ChangePassword"),
  ),
);
const ChangePasswordVerify = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/AuthProfile/ChangePasswordVerify"),
  ),
);
const LandingScreen = Loadable(
  lazyWithRetry(() => import("../../Screens/FrontendDesign/LandingScreen")),
);
const ProductImportResult = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Products/ProductImportResult"),
  ),
);
const InventoryTimeline = Loadable(
  lazyWithRetry(
    () =>
      import("../../Screens/AdminLayouts/ProductInventory/InventoryTimeline"),
  ),
);
const InventoryValidate = Loadable(
  lazyWithRetry(
    () =>
      import("../../Screens/AdminLayouts/ProductInventory/InventoryValidate/index"),
  ),
);
const SupplierTopupSettings = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Supplier/SupplierTopupSettings"),
  ),
);
const InventoryList = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/ProductInventory/InventoryList"),
  ),
);
// const SamplePage = Loadable(lazyWithRetry(() => import('./../../Screens/AdminLayouts/SamplePage')));
const ProductImages = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Products/ProductImages"),
  ),
);
const CustomerHelpService = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/CustomerHelpService")),
);
const Notifications = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/Notifications")),
);
const Taxation = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Taxation/TaxationList"),
  ),
);
const ServiceFeeList = Loadable(
  lazyWithRetry(
    () => import("../../Screens/AdminLayouts/Taxation/ServiceFeeList"),
  ),
);
const WalletList = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/Wallet/WalletList")),
);

const PinLogs = Loadable(
  lazyWithRetry(() => import("../../Screens/AdminLayouts/Reports/PinLogs")),
);

// ==============================|| MAIN ROUTING ||============================== //

const AdminRoutes = {
  path: "",
  element: <AdminLayouts />,
  children: [
    // --- Redirect authenticated users away from auth pages ---
    { path: "login", element: <AuthRedirect /> },
    { path: "forgot-password", element: <AuthRedirect /> },

    // --- Dashboard ---
    // The sidebar hides the link for anyone without the module, but the route
    // itself was exempt, so navigating to /dashboard still mounted the screen:
    // ten widgets fired, every one came back 403, and the user saw a page of
    // zeros plus a stack of permission warnings instead of a plain answer.
    // Root sends people to whatever they can actually see rather than assuming
    // the dashboard.
    { path: "", element: <AuthRedirect />, index: true },
    {
      element: <PermissionGuard permissionKey="dashboard" />,
      children: [{ path: "dashboard", element: <Dashboard /> }],
    },
    { path: "user-profile", element: <AuthProfile /> },
    { path: "change-password", element: <ChangePassword /> },
    { path: "change-password-verify", element: <ChangePasswordVerify /> },
    { path: "notifications", element: <Notifications /> },

    // --- Categories ---
    {
      element: <PermissionGuard permissionKey="categories" />,
      children: [{ path: "categories", element: <Categories /> }],
    },

    // --- Products ---
    {
      element: <PermissionGuard permissionKey="products" />,
      children: [
        { path: "products", element: <ProductList /> },
        { path: "products/add", element: <AddProduct /> },
        { path: "products/edit/:id", element: <AddProduct /> },
        { path: "products/detail/:id", element: <ProductDetail /> },
        { path: "product-images", element: <ProductImages /> },
        { path: "product-import-timeline", element: <ProductImportResult /> },
      ],
    },

    // --- Inventory ---
    {
      element: <PermissionGuard permissionKey="inventories" />,
      children: [
        { path: "inventory-validate", element: <InventoryValidate /> },
        { path: "inventory-list", element: <InventoryList /> },
        { path: "inventory-timeline", element: <InventoryTimeline /> },
      ],
    },

    // --- Employee ---
    {
      element: <PermissionGuard permissionKey="employee" />,
      children: [
        { path: "employee", element: <EmployeeManagement /> },
        { path: "employee/add", element: <AddEmployee /> },
        { path: "employee/edit/:id", element: <AddEmployee /> },
        { path: "employee/profile/:id", element: <EmployeeProfile /> },
      ],
    },

    // --- Roles ---
    {
      element: <PermissionGuard permissionKey="roles" />,
      children: [
        { path: "roles", element: <Roles /> },
        { path: "roles/add", element: <AddRoles /> },
        { path: "roles/edit/:id", element: <AddRoles /> },
      ],
    },

    // --- Orders ---
    {
      element: <PermissionGuard permissionKey="orders" />,
      children: [
        { path: "orders", element: <Orders /> },
        { path: "orders/detail/:id", element: <OrderDetails /> },
      ],
    },

    // --- Refunds (uses orders permission) ---
    {
      element: <PermissionGuard permissionKey="orders" />,
      children: [
        { path: "refunds", element: <Refunds /> },
        { path: "refunds/detail/:id", element: <RefundDetails /> },
      ],
    },

    // --- Customers ---
    {
      element: <PermissionGuard permissionKey="customers" />,
      children: [
        { path: "customers", element: <Customers /> },
        { path: "customers/detail/:id", element: <CustomersDetail /> },
      ],
    },

    // --- Supplier ---
    {
      element: <PermissionGuard permissionKey="supplier" />,
      children: [
        { path: "supplier", element: <SupplierList /> },
        { path: "supplier/detail/:id", element: <SupplierDetails /> },
        {
          path: "supplier/validation-logs",
          element: <SupplierValidationLogs />,
        },
        {
          path: "supplier/supplier-topup-setting",
          element: <SupplierTopupSettings />,
        },
        { path: "supplier-lavel", element: <SupplierLavel /> },
        {
          path: "products-link-with-supplier/:id",
          element: <MappingProductsAndSupplierCategory />,
        },
      ],
    },

    // --- CMS ---
    {
      element: <PermissionGuard permissionKey="cms" />,
      children: [{ path: "cms", element: <Settings /> }],
    },

    /*
     * Bank Transfers and Payment Failures are ORDERS work, not settings.
     *
     * Both sat behind the settings permission while the sidebar showed
     * them under Orders & Refunds with no permission check of its own. A
     * role with orders saw the link and was refused by the page -- which
     * is how this was reported.
     *
     * Approving a bank transfer confirms money received against an order,
     * and a payment failure is an order that was authorised and never
     * captured. Both belong to whoever handles orders, which is also where
     * the menu has always put them. Vijay's call, 30 Sep.
     */
    {
      element: <PermissionGuard permissionKey="orders" />,
      children: [
        { path: "bank-transfers", element: <BankTransfers /> },
        { path: "payment-failures", element: <PaymentFailures /> },
      ],
    },

    // --- Admin Settings ---
    {
      element: <PermissionGuard permissionKey="settings" />,
      children: [
        { path: "adminSettings", element: <AdminSettings /> },
        { path: "coupon-code", element: <CouponCode /> },
      ],
    },

    // --- Reports ---
    {
      element: <PermissionGuard permissionKey="reports" />,
      children: [
        { path: "product-reports", element: <ProductReports /> },
        { path: "payment", element: <PaymentReports /> },
        { path: "purchase", element: <SalesReports /> },
        { path: "reportLogs", element: <ReportLogs /> },
        /*
         * { path: "customers", element: <CustomerReports /> } was here, and
         * it never matched: the Customers tab registers the same path above
         * and wins. The screen behind it was a mock nobody could reach,
         * which is why it still held a hardcoded "John Doe" row.
         *
         * Its only real content -- orders, spend, first and last order --
         * is on the Customers tab now.
         */
        { path: "wallet-transactions", element: <WalletList /> },
        { path: "pinlogs", element: <PinLogs /> },
      ],
    },

    // --- Home Screen ---
    {
      element: <PermissionGuard permissionKey="home-screen" />,
      children: [{ path: "home-screen", element: <LandingScreen /> }],
    },

    // --- Profiles / Taxation ---
    {
      element: <PermissionGuard permissionKey="profile" />,
      children: [
        { path: "taxation", element: <Taxation /> },
        { path: "taxation/add", element: <AddTaxation /> },
        { path: "taxation/edit/:id", element: <AddTaxation /> },
        { path: "service-fee", element: <ServiceFeeList /> },
        { path: "service-fee/add", element: <AddServiceFee /> },
        { path: "service-fee/edit/:id", element: <AddServiceFee /> },
      ],
    },

    // --- Customer Help Service ---
    {
      element: <PermissionGuard permissionKey="customer-help-service" />,
      children: [
        { path: "customer-help-service", element: <CustomerHelpService /> },
      ],
    },

    // --- 404 fallback ---
    { path: "*", element: <NotFound /> },
  ],
};

export default AdminRoutes;
